<template>
  <div
    v-bind:data-id="win_id"
    class="mw_map_info_content geowerft"
    v-bind:class="[
      win_vermarktungsart &&
      win_vermarktungsart.toLowerCase() ===
        this.geoWerftData.texts.blur_hp_status_name.toLowerCase() &&
      this.geoWerftData.checkboxes.display_marketing_method === true
        ? 'mw-display-fremdobjekt'
        : '',
      win_homepage_status.replace(/\s+/g, '-').toLowerCase(),
    ]"
  >
    <div
      class="mw-geo-set-prop-offline-map"
      v-if="
        (true === this.geoWerftData.checkboxes.allow_prop_offline_detection &&
          ((true ===
            this.geoWerftData.checkboxes
              .allow_prop_offline_detection_only_logged_in &&
            this.geoWerftData.user.logged_in) ||
            false ===
              this.geoWerftData.checkboxes
                .allow_prop_offline_detection_only_logged_in) &&
          win_homepage_status &&
          win_homepage_status.toLowerCase() ===
            this.geoWerftData.texts.prop_offline_hp_status.toLowerCase()) ||
        (win_vermarktungsart &&
          win_vermarktungsart.toLowerCase() ===
            this.geoWerftData.texts.prop_offline_hp_status.toLowerCase())
      "
      @click="set_selected_prop_offline($event.target, win_id)"
    >
      <div
        title="Dieses Angebot ist nicht mehr verfügbar?"
        class="mw-set-prop-offline-content"
      >
        <img alt="" v-bind:src="this.geoWerftData.texts.prop_offline_picture" />
      </div>
    </div>
    <div
      v-if="
        ('ja' === (win_tour || '') || '1' === (win_tour || '')) &&
        this.geoWerftData.checkboxes.display_tour_icon
      "
      class="mw-list-tour-icon-wrapper"
    >
      <div class="tour-ico-wrapper">
        <img
          alt=""
          v-if="'' !== this.geoWerftData.customimages.tour_icon_src"
          v-bind:src="this.geoWerftData.customimages.tour_icon_src"
        />
      </div>
    </div>
    <h3>
      <span
        v-if="
          ((win_homepage_status &&
            win_homepage_status === 'Aktive Marktbeobachtung') ||
            (win_vermarktungsart && win_vermarktungsart === 'Fremdobjekt')) &&
          win_link_extern === '' &&
          false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
        "
        v-html="win_objekttitel"
      ></span>
      <a
        v-else-if="
          ((win_homepage_status &&
            win_homepage_status === 'Aktive Marktbeobachtung') ||
            (win_vermarktungsart && win_vermarktungsart === 'Fremdobjekt')) &&
          false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
        "
        :href="win_link_extern_url"
        target="_blank"
      >
        <span v-html="win_objekttitel"></span>
      </a>
      <a
        v-else-if="
          true === this.geoWerftData.show_extern_link &&
          win_link_extern_url !== '' &&
          false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
        "
        :href="win_link_extern_url"
        target="_blank"
      >
        <span v-html="win_objekttitel"></span>
      </a>
      <a v-else :href="permalink" target="_blank">
        <span
          v-if="this.geoWerftData.checkboxes.other_info_window"
          v-html="
            win_plz +
            ' ' +
            win_ort +
            ' | ' +
            capitalizeFirstLetter(win_objektart_raw)
          "
        ></span>
        <span v-else v-html="win_objekttitel"></span>
      </a>
    </h3>
    <div class="mw-obj-box-content-place">
      <span
        class="mw-gtb-watchlist-window-wrapper"
        v-if="
          true === this.geoWerftData.geowerft_gtb_active &&
          true === this.geoWerftData.geowerft_gtb_watchlist_active
        "
      >
        <span
          class="mw-gtb-like-wrapper"
          v-bind:data-current-id="win_id"
          v-if="this.geoWerftData.user.logged_in"
        >
          <span
            class="mw-watchlist-info-custom-icon-wrapper"
            v-if="
              '' !== this.geoWerftData.geowerft_setting_watchlist_icon_custom
            "
            v-bind:data-current-id="win_id"
            v-html="this.geoWerftData.geowerft_setting_watchlist_icon_custom"
            v-bind:id="'mw-gtb-like-in-window-' + win_id"
            v-on:click="mw_add_to_watchlist($event)"
          ></span>

          <svg
            v-else
            v-bind:id="'mw-gtb-like-in-window-' + win_id"
            v-on:click="mw_add_to_watchlist($event)"
            fill="#d8d8d8"
            width="23"
            height="19.67"
            viewBox="0 0 23 19.67"
            class=""
          >
            <path
              d="M2.138,53.753l8.117,7.579a1.826,1.826,0,0,0,2.489,0l8.117-7.579A6.721,6.721,0,0,0,23,48.833v-.261a6.421,6.421,0,0,0-10.961-4.542l-.539.539-.539-.539A6.421,6.421,0,0,0,0,48.573v.261a6.721,6.721,0,0,0,2.138,4.919Z"
              transform="translate(0 -42.151)"
            ></path>
          </svg>
        </span>
        <span
          class="mw-gtb-like-wrapper"
          v-bind:data-current-id="win_id"
          v-if="false === this.geoWerftData.user.logged_in"
          v-on:click="mw_gtb_open_login_or_register()"
        >
          <svg
            width="23"
            height="19.67"
            viewBox="0 0 23 19.67"
            fill="#d8d8d8"
            class=""
          >
            <path
              d="M2.138,53.753l8.117,7.579a1.826,1.826,0,0,0,2.489,0l8.117-7.579A6.721,6.721,0,0,0,23,48.833v-.261a6.421,6.421,0,0,0-10.961-4.542l-.539.539-.539-.539A6.421,6.421,0,0,0,0,48.573v.261a6.721,6.721,0,0,0,2.138,4.919Z"
              transform="translate(0 -42.151)"
            ></path>
          </svg>
        </span>
        <span
          class="mw-gtb-list-wrapper"
          v-bind:data-current-id="win_id"
          v-if="this.geoWerftData.user.logged_in"
          v-on:click="mw_open_watchlist()"
        >
          <svg
            fill="#5e5e5e"
            width="21"
            height="21"
            viewBox="0 0 24 24"
            xml:space="preserve"
          >
            <g id="sort">
              <g><rect x="7" y="2" width="16" height="2"></rect></g>
              <g><rect x="7" y="8" width="14" height="2"></rect></g>
              <g><rect x="1" y="1" width="4" height="4"></rect></g>
              <g><rect x="7" y="14" width="12" height="2"></rect></g>
              <g><rect x="1" y="13" width="4" height="4"></rect></g>
              <g><rect x="7" y="20" width="10" height="2"></rect></g>
              <g><rect x="1" y="19" width="4" height="4"></rect></g>
              <g><rect x="1" y="7" width="4" height="4"></rect></g>
            </g>
          </svg>
        </span>
        <span
          class="mw-gtb-list-wrapper"
          v-bind:data-current-id="win_id"
          v-if="false === this.geoWerftData.user.logged_in"
          v-on:click="mw_gtb_open_login_or_register()"
        >
          <svg
            fill="#5e5e5e"
            width="21"
            height="21"
            viewBox="0 0 24 24"
            xml:space="preserve"
          >
            <g id="sort">
              <g><rect x="7" y="2" width="16" height="2"></rect></g>
              <g><rect x="7" y="8" width="14" height="2"></rect></g>
              <g><rect x="1" y="1" width="4" height="4"></rect></g>
              <g><rect x="7" y="14" width="12" height="2"></rect></g>
              <g><rect x="1" y="13" width="4" height="4"></rect></g>
              <g><rect x="7" y="20" width="10" height="2"></rect></g>
              <g><rect x="1" y="19" width="4" height="4"></rect></g>
              <g><rect x="1" y="7" width="4" height="4"></rect></g>
            </g>
          </svg>
        </span>
      </span>
      <span
        v-if="this.geoWerftData.checkboxes.other_info_window"
        v-html="win_kennung"
      ></span>
      <span v-else-if="win_homepage_status.toLowerCase() === 'bieterverfahren'">
        <img
          class="auction-pin-infowindow"
          v-bind:src="geoWerftData.texts.auction_popup_picture"
          alt=""
        />
        <span class="info-window-auction-label">Angebot</span>
        <span
          v-if="false === geoWerftData.checkboxes.set_geolocation"
          v-html="win_plz"
        ></span>
        <span
          v-if="false === geoWerftData.checkboxes.set_geolocation"
          v-html="win_ort"
        ></span>
        <span
          v-if="true === geoWerftData.checkboxes.set_geolocation"
          v-html="win_geolocation"
        ></span>
        | <span v-html="capitalizeFirstLetter(win_objektart_raw)"></span>
      </span>
      <span v-else>
        <em class="fa fa-map-marker"></em>
        <span
          v-if="false === geoWerftData.checkboxes.set_geolocation"
          v-html="win_plz"
        ></span>
        <span
          v-if="false === geoWerftData.checkboxes.set_geolocation"
          v-html="win_ort"
        ></span>
        <span
          v-if="
            true === geoWerftData.checkboxes.set_geolocation &&
            win_vermarktungsart &&
            win_vermarktungsart.toLowerCase() === 'zukunftsmarktradar'
          "
          v-html="win_plz + ' | '"
        ></span>
        <span
          v-if="true === geoWerftData.checkboxes.set_geolocation"
          v-html="win_geolocation"
        ></span>
        | <span v-html="capitalizeFirstLetter(win_objektart_raw)"></span>
      </span>
    </div>
    <div
      class="mw_map_inner_left"
      @click="
        map_trigger_ajax_request('', {
          kennung: win_kennung,
          link: win_link_extern,
        })
      "
    >
      <div
        v-if="
          isNaN(
            geowerft_map_get_banner(
              win_homepage_status.toLowerCase(),
              win_erwerbsart.toLowerCase(),
              win_res_begin,
              win_res_ende,
              win_price,
              win_price_rent,
              win_display_badge_new
            )
          )
        "
        class="geowerft-banner-small-info-window-wrapper"
      >
        <div
          v-bind:class="
            'geowerft-banner-small-info-window ' +
            geowerft_map_get_banner(
              win_homepage_status.toLowerCase(),
              win_erwerbsart.toLowerCase(),
              win_res_begin,
              win_res_ende,
              win_price,
              win_price_rent,
              win_display_badge_new
            )
          "
          v-html="
            geowerft_map_get_banner(
              win_homepage_status.toLowerCase(),
              win_erwerbsart.toLowerCase(),
              win_res_begin,
              win_res_ende,
              win_price,
              win_price_rent,
              win_display_badge_new
            )
          "
        ></div>
      </div>
      <span
        v-if="
          ((win_homepage_status &&
            win_homepage_status === 'Aktive Marktbeobachtung') ||
            (win_vermarktungsart && win_vermarktungsart === 'Fremdobjekt')) &&
          win_link_extern === '' &&
          false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
        "
        ><img
          v-if="image_url"
          :src="image_url"
          loading="lazy"
          style="max-width: 150px; max-height: 100px"
      /></span>
      <a
        v-else-if="
          ((win_homepage_status &&
            win_homepage_status === 'Aktive Marktbeobachtung') ||
            (win_vermarktungsart && win_vermarktungsart === 'Fremdobjekt')) &&
          false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
        "
        class="mw-filter-presentation-image-link"
        :href="win_link_extern_url"
        target="_blank"
      >
        <img
          v-if="image_url"
          :src="image_url"
          loading="lazy"
          style="max-width: 150px; max-height: 100px"
        />
      </a>
      <a
        v-else-if="
          true === this.geoWerftData.show_extern_link &&
          win_link_extern_url !== '' &&
          false === this.geoWerftData.checkboxes.custom_marketwatch_temp_active
        "
        class="mw-filter-presentation-image-link"
        :href="win_link_extern_url"
        target="_blank"
      >
        <img
          v-if="image_url"
          :src="image_url"
          loading="lazy"
          style="max-width: 150px; max-height: 100px"
        />
      </a>
      <a
        v-else
        class="mw-filter-presentation-image-link"
        :href="permalink"
        target="_blank"
      >
        <img
          v-if="image_url"
          :src="image_url"
          loading="lazy"
          style="max-width: 150px; max-height: 100px"
        />
      </a>
    </div>
    <div
      class="mw_map_inner_right"
      @click="
        map_trigger_ajax_request('', {
          kennung: win_kennung,
          link: win_link_extern,
        })
      "
    >
      <span
        class="span-wrapper-price buy"
        v-if="
          (win_homepage_status &&
            win_homepage_status === 'Aktive Marktbeobachtung') ||
          (win_vermarktungsart && win_vermarktungsart === 'Fremdobjekt')
        "
        ><span
          v-bind:class="
            this.geoWerftData.user.user_fully_logged_in
              ? 'logged_in kaufpreis'
              : 'logged_out kaufpreis'
          "
          v-if="
            false === isNaN(win_price) &&
            ('kauf' === win_erwerbsart.toLowerCase() ||
              'buy' === win_erwerbsart.toLowerCase())
          "
          >Kaufpreis: {{ get_format_price(win_price) || format - price }}
          {{ geoWerftData.texts.currency_suffix }}<br /></span
      ></span>
      <span
        class="span-wrapper-price rent"
        v-if="
          (win_homepage_status &&
            win_homepage_status === 'Aktive Marktbeobachtung') ||
          (win_vermarktungsart && win_vermarktungsart === 'Fremdobjekt')
        "
        ><span
          v-bind:class="
            this.geoWerftData.user.user_fully_logged_in
              ? 'logged_in mietpreis'
              : 'logged_out mietpreis'
          "
          v-if="
            false === isNaN(win_price_rent) &&
            ('miete' === win_erwerbsart.toLowerCase() ||
              'rent' === win_erwerbsart.toLowerCase())
          "
          >Mietpreis:
          {{ get_format_price(win_price_rent) || format - price }}
          {{ geoWerftData.texts.currency_suffix }}<br /></span
      ></span>
      <span
        class="span-prop-kennung"
        v-if="false === this.geoWerftData.checkboxes.other_info_window"
      >
        <span
          v-html="
            this.geoWerftData.texts.info_window_obj_nr + ' ' + win_kennung
          "
        ></span
        ><br />
      </span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in mietpreis'
            : 'logged_out mietpreis'
        "
        v-if="win_price_qm"
        >{{ this.geoWerftData.texts.mietpreis_pro_qm_pre
        }}{{ get_format_price(win_price_qm)
        }}{{ this.geoWerftData.texts.mietpreis_pro_qm_post }}<br
      /></span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in buerofleache'
            : 'logged_out bueroflaeche'
        "
        v-if="win_bueroflaeche"
        >Bürofläche: {{ win_bueroflaeche }} m²<br
      /></span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in teilbarab'
            : 'logged_out teilbarab'
        "
        v-if="win_teilbarkeit"
        >Teilbarkeit ab: {{ win_teilbarkeit }} m²<br
      /></span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in bezug'
            : 'logged_out bezug'
        "
        v-if="win_bezug"
        >{{ this.geoWerftData.texts.label_bezug_ab_map_view }}{{ win_bezug
        }}<br
      /></span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in zimmer'
            : 'logged_out zimmer'
        "
        v-if="win_zimmer"
        >Zimmer: <span v-html="win_zimmer.replace('.', ',')"></span><br
      /></span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in anzahl_erwachsene'
            : 'logged_out anzahl_erwachsene'
        "
        v-if="win_count_adults"
        >Anzahl Erwachsene: <span v-html="win_count_adults"></span><br
      /></span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in anzahl_kinder'
            : 'logged_out anzahl_kinder'
        "
        v-if="win_count_childs"
        >Anzahl Kinder: <span v-html="win_count_childs"></span><br
      /></span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in barrierefrei'
            : 'logged_out barrierefrei'
        "
        v-if="win_barrierefrei"
        >Barrierefrei:
        <span class="geowerft-cb-check"
          ><em class="fa fa-check-square" aria-hidden="true"></em></span
        ><br
      /></span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in haustiere'
            : 'logged_out haustiere'
        "
        v-if="win_haustiere"
        >Haustiere:
        <span class="geowerft-cb-check"
          ><em class="fa fa-check-square" aria-hidden="true"></em></span
        ><br
      /></span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in wohnflaeche'
            : 'logged_out wohnflaeche'
        "
        v-if="
          win_wohnflaeche &&
          -1 === win_objektart_raw.toLowerCase().indexOf('invest')
        "
        >Wohnfläche: <span v-html="win_wohnflaeche"></span> m²<br
      /></span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in vermietbareflaeche'
            : 'logged_out vermietbareflaeche'
        "
        v-if="
          win_vermietbare_flaeche &&
          -1 !== win_objektart_raw.toLowerCase().indexOf('invest')
        "
        >Vermietbare Fläche:
        <span v-html="win_vermietbare_flaeche"></span> m²<br
      /></span>
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in grundflaeche'
            : 'logged_out grundflaeche'
        "
        v-if="
          win_grundstuecksflaeche &&
          !(
            (win_homepage_status &&
              win_homepage_status === 'Aktive Marktbeobachtung') ||
            (win_vermarktungsart && win_vermarktungsart === 'Fremdobjekt')
          )
        "
        >Grundstücksfläche:
        <span v-html="win_grundstuecksflaeche"></span> m²</span
      >
      <span
        v-bind:class="
          this.geoWerftData.user.user_fully_logged_in
            ? 'logged_in gesamtflaeche'
            : 'logged_out gesamtflaeche'
        "
        v-if="
          win_gesamtflaeche && this.geoWerftData.checkboxes.display_ges_flaeche
        "
        >Gesamtfläche: <span v-html="win_gesamtflaeche"></span> m²</span
      >
      <span
        class="span-desination-wrapper"
        v-if="
          (((win_homepage_status &&
            win_homepage_status === 'Aktive Marktbeobachtung') ||
            (win_vermarktungsart && win_vermarktungsart === 'Fremdobjekt')) &&
            false ===
              this.geoWerftData.checkboxes.custom_marketwatch_temp_active) ||
          (this.geoWerftData.checkboxes.display_sorce_in_market_watch &&
            win_vermarktungsart &&
            win_vermarktungsart.toLowerCase() ===
              this.geoWerftData.texts.market_watch_name.toLowerCase())
        "
      >
        Quelle:
        <span v-if="win_link_extern !== ''" v-html="win_link_extern"></span>
        <span v-else v-html="win_kennung"></span> <br />
      </span>
      <!--Anpassung um den Preis mit anzuzeigen-->
      <div
        class="infowindow-whole-price-wrapper"
        v-if="
          true ===
          this.geoWerftData.checkboxes.show_price_in_paginated_info_window
        "
      >
        <div class="infowindow-price-wrapper">
          <div
            v-html="
              get_price_label(
                win_homepage_status,
                win_vermarktungsart,
                win_price_rent,
                win_price,
                win_erwerbsart
              )
            "
            class="label-wrapper"
          ></div>
          <div
            v-html="
              get_price(
                win_homepage_status,
                win_vermarktungsart,
                win_price_rent,
                win_price,
                win_erwerbsart
              )
            "
            class="price-wrapper"
          ></div>
        </div>
      </div>
      <!--Anpassung hinzufügen, für andere neue Variante in der Marktbeobachtung-->
      <span
        class="span-destination-wrapper-new"
        v-if="
          'true' === this.geoWerftData.texts.diff_extern_link &&
          (win_homepage_status === 'Aktive Marktbeobachtung' ||
            win_homepage_status === 'Fremdobjekt' ||
            this.geoWerftData.marketwatch_extern_links_hp.includes(
              win_homepage_status
            ))
        "
      >
        <span class="mw-extern-view-wrapper">
          <span class="single-button-wrapper wrapper-left">
            <a
              class="single-extern-btn important"
              v-bind:href="win_link_extern_url"
              target="_blank"
            >
              Zum Angebot
            </a>
          </span>
          <span class="single-button-wrapper wrapper-right">
            <a
              class="single-extern-btn not-important"
              v-bind:href="permalink"
              target="_blank"
            >
              Zum Vergleich
            </a>
          </span>
        </span>
      </span>
      <span class="span-destination-wrapper-old" v-else>
        <span
          v-if="
            ((win_homepage_status &&
              win_homepage_status === 'Aktive Marktbeobachtung') ||
              (win_vermarktungsart && win_vermarktungsart === 'Fremdobjekt')) &&
            win_link_extern === '' &&
            false === geoWerftData.checkboxes.custom_marketwatch_temp_active
          "
        ></span>
        <span v-else>
          <div class="mw-obj-box-content-details">
            <a
              v-if="
                ((win_homepage_status &&
                  win_homepage_status === 'Aktive Marktbeobachtung') ||
                  (win_vermarktungsart &&
                    win_vermarktungsart === 'Fremdobjekt')) &&
                win_link_extern_url !== '' &&
                false ===
                  this.geoWerftData.checkboxes.custom_marketwatch_temp_active
              "
              class="btn-details"
              :href="win_link_extern_url"
              target="_blank"
            >
              {{ this.geoWerftData.texts.label_details }}
            </a>
            <a
              v-else-if="
                ((win_homepage_status &&
                  win_homepage_status === 'Aktive Marktbeobachtung') ||
                  (win_vermarktungsart &&
                    win_vermarktungsart === 'Fremdobjekt')) &&
                true === this.geoWerftData.checkboxes.logged_in_market_watch &&
                false === this.geoWerftData.user.logged_in
              "
              class="btn-details"
              :href="this.geoWerftData.texts.market_watch_alt_link"
              target="_blank"
            >
              {{ this.geoWerftData.texts.label_details }}
            </a>
            <a
              v-else-if="
                true === this.geoWerftData.show_extern_link &&
                win_link_extern_url !== '' &&
                false ===
                  this.geoWerftData.checkboxes.custom_marketwatch_temp_active
              "
              class="btn-details"
              :href="win_link_extern_url"
              target="_blank"
            >
              {{ this.geoWerftData.texts.label_details }}
            </a>
            <a
              v-else-if="
                false === this.geoWerftData.user.logged_in &&
                true === this.geoWerftData.user.link_for_logged_in_only
              "
              class="btn-details"
              :href="this.geoWerftData.user.link_for_logged_in_only_url"
            >
              {{ this.geoWerftData.user.link_for_logged_in_only_label }}
            </a>
            <a v-else class="btn-details" :href="permalink" target="_blank">
              {{ this.geoWerftData.texts.label_details }}
            </a>
          </div>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import objectList from "./objectList.vue";

export default {
  name: "InfoWindow",
  computed: {
    objectList() {
      return objectList;
    },
  },
  props: [
    "win_id",
    "geoWerftData",
    "image_url",
    "permalink",
    "win_objekttitel",
    "win_plz",
    "win_ort",
    "win_geolocation",
    "win_objektart_raw",
    "win_kennung",
    "win_gesamtflaeche",
    "win_tour",
    "win_res_begin",
    "win_res_ende",
    "win_price",
    "win_price_rent",
    "win_display_badge_new",
    "win_erwerbsart",
    "win_vermarktungsart",
    "win_homepage_status",
    "win_count_adults",
    "win_count_childs",
    "win_barrierefrei",
    "win_haustiere",
    "win_price",
    "win_price_rent",
    "win_price_qm",
    "win_teilbarkeit",
    "win_bueroflaeche",
    "win_bezug",
    "win_zimmer",
    "win_wohnflaeche",
    "win_vermietbare_flaeche",
    "win_grundstuecksflaeche",
    "win_link_extern",
    "win_link_extern_url",
  ],
  methods: {
    mw_add_to_watchlist(event) {
      const current_clicked_elm = event.target;
      const current_id = current_clicked_elm
        .closest("span")
        .getAttribute("data-current-id");
      let current_elm_liked = false;
      let current_type = "POST";
      if (current_clicked_elm.classList.contains("mw-gtb-watchlist-liked")) {
        current_elm_liked = true;
        current_type = "DELETE";
      }

      if (false === current_elm_liked) {
        current_clicked_elm.classList.add("mw-gtb-watchlist-liked");
      } else {
        current_clicked_elm.classList.remove("mw-gtb-watchlist-liked");
      }

      if (current_id && document.querySelector("#watch-class-" + current_id)) {
        if (document.querySelector("#watch-class-" + current_id)) {
          if (
            document
              .querySelector("#watch-class-" + current_id)
              .classList.contains("mw-watchlist-delete")
          ) {
            document
              .querySelector("#watch-class-" + current_id)
              .classList.remove("mw-watchlist-delete");
            document
              .querySelector("#watch-class-" + current_id)
              .classList.replace("fa-star", "fa-star-o");
            document
              .querySelector("#watch-class-" + current_id)
              .classList.replace("fa-heart", "fa-heart-o");
          } else {
            document
              .querySelector("#watch-class-" + current_id)
              .classList.add("mw-watchlist-delete");
            document
              .querySelector("#watch-class-" + current_id)
              .classList.replace("fa-star-o", "fa-star");
            document
              .querySelector("#watch-class-" + current_id)
              .classList.replace("fa-heart-o", "fa-heart");
          }
        }
      }
      fetch(this.geoWerftData.geowerft_gtb_watchlist_rest, {
        method: current_type,
        headers: {
          "Content-Type": "application/json",
          "X-WP-Nonce": this.geoWerftData.texts.wp_nonce,
        },
        body: JSON.stringify({ post_id: current_id }),
      })
        .then((response) => response.json())
        .then((data) => {});
    },
    mw_open_watchlist() {
      if (document.querySelector(".mw-ben-dialog-watchlist")) {
        document.querySelector(".mw-ben-dialog-watchlist").click();
      }
    },
    mw_gtb_open_login_or_register() {
      if (document.querySelector("#mw-ben-main-dialog")) {
        document.querySelector("#mw-ben-main-dialog").showModal();
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    get_price_label(
      win_homepage_status,
      win_vermarktungsart,
      win_price_rent,
      win_price,
      win_erwerbsart
    ) {
      if (
        (win_homepage_status &&
          !(
            win_homepage_status &&
            win_homepage_status === "Aktive Marktbeobachtung"
          )) ||
        (win_vermarktungsart && win_vermarktungsart === "Fremdobjekt")
      ) {
        var price_label = "";
        var current_hp_status = win_homepage_status.toLowerCase();
        var current_price_rent = win_price_rent;
        var current_price_buy = win_price;
        switch (win_erwerbsart.toLowerCase()) {
          case "miete":
          case "rent":
            price_label = this.geoWerftData.texts.display_text_price_rent;
            // Hier noch die verschiedenen HP Status prüfen und ggf. das Label anpassen.
            if (
              current_hp_status === "verkauft" ||
              current_hp_status === "referenz"
            ) {
              price_label = "Vermietet";
            }
            if (current_hp_status === "in vorbereitung") {
              price_label = "In Vorbereitung";
            }
            if (current_hp_status === "bieterverfahren") {
              price_label = "Bieterverfahren";
            }
            // Hier noch Prüfen ob, eine Preisblende eingefügt werden muss.
            if (current_price_rent && isNaN(current_price_rent)) {
              price_label = current_price_rent;
            }
            break;
          case "buy":
          case "kauf":
            price_label = this.geoWerftData.texts.display_text_price_purchase;
            // Hier noch die verschiedenen HP Status prüfen und ggf. das Label anpassen.
            if (
              current_hp_status === "verkauft" ||
              current_hp_status === "referenz"
            ) {
              price_label = "Verkauft";
            }
            if (current_hp_status === "in vorbereitung") {
              price_label = "In Vorbereitung";
            }
            if (current_hp_status === "bieterverfahren") {
              price_label = "Bieterverfahren";
            }
            // Hier noch Prüfen ob, eine Preisblende eingefügt werden muss.
            if (current_price_buy && isNaN(current_price_buy)) {
              price_label = current_price_buy;
            }
            break;
        }
        return price_label;
      }
      return;
    },
    get_price(
      win_homepage_status,
      win_vermarktungsart,
      win_price_rent,
      win_price,
      win_erwerbsart
    ) {
      if (
        (win_homepage_status &&
          !(
            win_homepage_status &&
            win_homepage_status === "Aktive Marktbeobachtung"
          )) ||
        (win_vermarktungsart && win_vermarktungsart === "Fremdobjekt")
      ) {
        var price = "";
        var current_hp_status = win_homepage_status.toLowerCase();
        var current_price_rent = win_price_rent;
        var current_price_buy = win_price;
        switch (win_erwerbsart.toLowerCase()) {
          case "rent":
          case "miete":
            if (current_price_rent && !isNaN(current_price_rent)) {
              price =
                this.get_format_price(current_price_rent) +
                " " +
                this.geoWerftData.texts.currency_suffix;
              if (
                current_hp_status === "verkauft" ||
                current_hp_status === "referenz"
              ) {
                price = "";
              }
              if (current_hp_status === "in vorbereitung") {
                price = "";
              }
              if (current_hp_status === "bieterverfahren") {
                price = "";
              }
            }
            break;
          case "kauf":
          case "buy":
            if (current_price_buy && !isNaN(current_price_buy)) {
              price =
                this.get_format_price(current_price_buy) +
                " " +
                this.geoWerftData.texts.currency_suffix;
              if (
                current_hp_status === "verkauft" ||
                current_hp_status === "referenz"
              ) {
                price = "";
              }
              if (current_hp_status === "in vorbereitung") {
                price = "";
              }
              if (current_hp_status === "bieterverfahren") {
                price = "";
              }
            }
            break;
        }
        return price;
      }
      return;
    },
    map_trigger_ajax_request(current_prop, possible_values) {
      // Ajax erst einmal nur für Aktive markbeobachtung nutzen.
      if (
        true === this.geoWerftData.user.logged_in &&
        true === this.geoWerftData.checkboxes.enable_market_watch_ajax
      ) {
        if (
          current_prop &&
          ("aktive marktbeobachtung" ===
            current_prop.homepage_status.toLowerCase() ||
            "fremdobjekt" === current_prop.vermarktungsart.toLowerCase())
        ) {
          jQuery.ajax({
            type: "POST",
            url: this.geoWerftData.texts.ajax_url,
            data: {
              action: "handle_marked_watch_click",
              current_link: possible_values["link"],
              current_id: possible_values["kennung"],
              akt_kind: this.geoWerftData.texts.market_watch_akt_kind,
              akt_type: this.geoWerftData.texts.market_watch_akt_type,
              current_user_id: this.geoWerftData.user.current_user_id,
            },
            success: function (response) {},
          });
        }
      }
    },
    geowerft_map_get_banner(
      homepage_status,
      erwerbsart,
      reservierung_begin,
      reservierung_ende,
      price,
      price_rent,
      display_badge_new = ""
    ) {
      var result = "";
      // Preis Gegen Gebot.
      if (
        "kauf" === erwerbsart ||
        ("buy" === erwerbsart &&
          isNaN(parseInt(price)) &&
          undefined !== price &&
          "" !== price)
      ) {
        result = price;
      }
      if (
        "miete" === erwerbsart ||
        ("rent" === erwerbsart &&
          isNaN(parseInt(price_rent)) &&
          undefined !== price_rent &&
          "" !== price_rent)
      ) {
        result = price_rent;
      }
      // Verkauft und Vermietet.
      if ("verkauft" === homepage_status || "referenz" === homepage_status) {
        if ("kauf" === erwerbsart || "buy" === erwerbsart) {
          result = "Verkauft";
        } else {
          result = "Vermietet";
        }
      }
      if ("in vorbereitung" === homepage_status) {
        result = "In Vorbereitung";
      }
      if (display_badge_new !== "") {
        result = "Neu";
      }
      // Reserviert.
      if (
        (reservierung_ende !== undefined &&
          reservierung_ende !== "" &&
          Date.parse(this.convert_date_format(reservierung_ende)) >=
            Date.now()) ||
        (reservierung_begin !== undefined &&
          reservierung_begin !== "" &&
          (reservierung_ende === undefined || reservierung_ende === "") &&
          Date.parse(this.convert_date_format(reservierung_begin)) <=
            Date.now())
      ) {
        result = "Reserviert";
      }
      return result;
    },
    get_format_price(number) {
      if (undefined === number || "" === number) {
        return "";
      }
      if (this.geoWerftData.checkboxes.format_prices_cb) {
        number = number.toString().replace(",", ".");
        let val = (number / 1).toFixed(2).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      } else {
        number = parseInt(number);
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    convert_date_format(input) {
      var format = "dd.mm.yyyy"; // default format
      var parts = input.match(/(\d+)/g),
        i = 0,
        fmt = {};
      // extract date-part indexes from the format
      format.replace(/(yyyy|dd|mm)/g, function (part) {
        fmt[part] = i++;
      });

      return new Date(
        parts[fmt["yyyy"]],
        parts[fmt["mm"]] - 1,
        parts[fmt["dd"]]
      );
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/InfoWindow.vue